import { CanActivateFn } from '@angular/router';

import { sessionGuard } from '@/core/auth/guards/session.guard';
import { UserRole } from '@/core/auth/types/auth.types';
import { DEFAULT_GRADE_SLUG } from '@/shared/utils/curriculum/curriculum';

export function rolesGuard(...allowed: UserRole[]): CanActivateFn {
  return sessionGuard((store, router) => {
    const role = store.role();
    if (role && allowed.includes(role)) return true;
    const grade = store.gradeSlug() ?? DEFAULT_GRADE_SLUG;
    return router.parseUrl(store.isAuthenticated() ? `/${grade}/student-home` : '/login');
  });
}
